module.exports = __webpack_public_path__ + "img/p2-91.c6dfbdf0.png";